import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import Login from "./pages/AuthenticationPages/Login";
import "./App.css";
import config from "./config";
import AuthContainer from "./pages/AuthenticationPages/AuthContainer";
import NotFound from "./pages/NotFound/NotFound";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import utilityFunctions from "./store/utilityFunctions";
import LoadingPage from "./components/Loading/Loading";
import PageWithNavbar from "./pageContainers/PageWithNavbar/PageWithNavbar";
import Warranties from "./pages/Warranties/Warranties";
import SearchTicket from "./pages/SearchTicket/SearchTicket";

import TicketDetail from "./pages/SearchTicket/TicketDetail/TicketDetail";

import Inventory from "./pages/Inventory/Inventory";
import Reports from "./pages/Reports/Reports";
import SingleWarranty from "./pages/Warranties/SingleWarranty/SingleWarranty";
import Dashboard from "./pages/Dashboard/Dashboard";
import ServiceCenterList from "./pages/ServiceCenter/ServiceCenterList";
import ServiceCenterDetail from "./pages/ServiceCenter/ServiceCenterDetail";
import Customers from "./pages/CustomerList/Customers";

import CustomerDetail from "./pages/CustomerDetail/CustomerDetail";
import AddNewDevice from "./pages/CustomerDetail/Devices/AddNewDevice/AddNewDevice";
import ManageStaff from "./pages/ManageStaff/ManageStaff";
import StaffDetail from "./pages/ManageStaff/StaffDetail/StaffDetail";
import StaffAdd from "./pages/ManageStaff/StaffAdd/StaffAdd";
import Users from "./pages/Users/Users";
import Device from "./pages/Device/Device";
import Sellers from "./pages/Sellers/Sellers";
import DeviceDetail from "./pages/Device/DeviceDetail/DeviceDetail";
import SingleUser from "./pages/Users/SingleUser/SingleUser";
import ForgotPasswordConfirm from "./pages/AuthenticationPages/ForgotPasswordConfirm";
import ForgotPassword from "./pages/AuthenticationPages/ForgotPassword";
import DefaultSettings from "./pages/Settings/DefaultSettings";
import errorFunctions from "./store/errorFunctions";
// import Commercial from "./pages/Sellers/Commercials";

const ROLES = {
  ADMIN: "Admin",
  SERVICE_CENTER_ADMIN: "Service Center Admin",
  CONTRACTOR: "Contractor",
  COMMERCIAL_ADMIN: "Commercial Admin",
  COMMERCIAL_STAFF: "Commercial Staff",
};
const userinfo =
  localStorage.getItem("userInfo") || utilityFunctions.getCookie("userInfo");
const hasRole = (user, roles) => {
  const userRole = user?.user?.role;
  return Array.isArray(roles) ? roles.includes(userRole) : roles === userRole;
};

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isVerified: false, // Set to true if account is verified (in authentication check)
      isSuper: false, // On load, backend says if account is super admin or not
      userInfo: userinfo && JSON.parse(userinfo),
      selectedbrandID: utilityFunctions.getCookie("brandId") || "",
      brands: [],
      employees: null,
    };

    // Check if token exists, and if does set it
  }

  componentDidMount() {
    this.validateUser();
    document.title =
      config.country === "AU"
        ? "Dreame Australia - Admin"
        : "Dreame New Zeland - Admin";
    // this.retrieveEmployeeList();
  }

  validateUser(callback) {
    // Check userInfo and whether it is valid or not
    if (this.state.userInfo) {
      // Need to validate token with server
      const payload = {
        token: this.state.userInfo.access_token,
      };

      this.protectedFetch(
        config.backendServer + "token/verify/",
        "POST",
        payload,
        errorFunctions.checkResponseThenJson
      )
        .then((res) => {
          // On resolved and rejected, need to take off loading screen

          this.setState(
            {
              isLoading: false,
              isVerified: true,
              isSuper: !!res.super /* force boolean */,
            },
            () => {
              if (callback) {
                callback();
              }
            }
          );
        })
        .catch(() => {
          this.setState({ isLoading: false }, () => {
            if (callback) {
              callback();
            }
          });
          utilityFunctions.setCookie("userInfo", "", -20); //Setting expires to past should delete cookie
          localStorage.removeItem("userInfo");
        });
      // this.getBrands()
    } else {
      // If not logged in, routes will handle rest
      this.setState({ isLoading: false }, () => {
        if (callback) {
          callback();
        }
      });
      utilityFunctions.setCookie("userInfo", "", -20); //Setting expires to past should delete cookie
      localStorage.removeItem("userInfo");
    }
  }

  userHasAuthenticated = (userInfo, rememberMe, callback) => {
    if (userInfo) {
      this.setState({ userInfo: JSON.parse(userInfo) });
      if (rememberMe) {
        localStorage.setItem("userInfo", userInfo);
        localStorage.setItem("brandId", userInfo.user.brands.id);
      } else {
        utilityFunctions.setCookie("userInfo", userInfo);
        // const userInfoJson = userInfo && JSON.parse(userInfo);
        // utilityFunctions.setCookie("brandId", userInfoJson.user.brands[0].id);
      }
    }
    this.validateUser(() => {
      if (callback) {
        callback();
      }
    });
  };
  handleLogout = () => {
    this.userHasAuthenticated(false);
    this.setState({ userInfo: null });
    utilityFunctions.setCookie("userInfo", "", -20); //Setting expires to past should delete cookie
    localStorage.removeItem("userInfo");
    window.location.href = "/login";
  };

  protectedFetch = (url, method, data, checkFunction, isFormData) => {
    const user =
      localStorage.getItem("userInfo") ||
      utilityFunctions.getCookie("userInfo");
    const userInfo = user && JSON.parse(user);
    const token = userInfo?.access_token;
    const logout = this.handleLogout;

    // Validate method
    const validMethods = ["GET", "POST", "PUT", "PATCH", "DELETE"];
    if (!validMethods.includes(method.toUpperCase())) {
      return Promise.reject({
        type: "INVALID_METHOD",
        message: `Invalid HTTP method: ${method}. Must be one of: ${validMethods.join(
          ", "
        )}`,
      });
    }

    return new Promise(function (resolve, reject) {
      let options = {
        method: method,
        headers: {
          Authorization: "Bearer " + token,
        },
        // Add timeout for all requests
        timeout: 30000, // 30 seconds
      };

      // Handle different methods appropriately
      switch (method.toUpperCase()) {
        case "GET":
          // For GET requests, data should be query parameters
          if (data) {
            const queryParams = new URLSearchParams(data);
            url = `${url}?${queryParams.toString()}`;
          }
          break;

        case "POST":
        case "PUT":
        case "PATCH":
          if (isFormData) {
            options.body = data;
          } else {
            options.headers["Content-Type"] = "application/json";
            options.body = JSON.stringify(data || {});
          }
          break;

        case "DELETE":
          // DELETE requests might have a body in some cases
          if (data) {
            options.headers["Content-Type"] = "application/json";
            options.body = JSON.stringify(data);
          }
          break;
      }

      // Add retry logic for failed requests
      const maxRetries = 3;
      let retryCount = 0;

      const attemptFetch = () => {
        fetch(url, options)
          .then(async (response) => {
            if (!response.ok) {
              const errorData = await response.json().catch(() => ({}));
              const errorMessage = errorData.message || response.statusText;

              // Handle specific status codes
              switch (response.status) {
                case 400:
                  reject({ type: "BAD_REQUEST", message: errorMessage });
                  break;
                case 401:
                  reject({
                    type: "UNAUTHORIZED",
                    message: "Session expired. Please login again.",
                  });
                  logout();
                  break;
                case 403:
                  reject({
                    type: "FORBIDDEN",
                    message:
                      "You do not have permission to perform this action.",
                  });
                  break;
                case 404:
                  reject({
                    type: "NOT_FOUND",
                    message: "The requested resource was not found.",
                  });
                  break;
                case 409:
                  reject({
                    type: "CONFLICT",
                    message: "Resource conflict detected.",
                  });
                  break;
                case 413:
                  reject({
                    type: "NOT_VERIFIED",
                    message: "Your account needs to be verified.",
                  });
                  break;
                case 422:
                  reject({ type: "VALIDATION_ERROR", message: errorMessage });
                  break;
                case 429:
                  // Handle rate limiting with retry
                  if (retryCount < maxRetries) {
                    retryCount++;
                    const retryAfter =
                      response.headers.get("Retry-After") || 1000;
                    setTimeout(attemptFetch, retryAfter);
                    return;
                  }
                  reject({
                    type: "TOO_MANY_REQUESTS",
                    message: "Too many requests. Please try again later.",
                  });
                  break;
                case 500:
                case 502:
                case 503:
                case 504:
                  // Retry on server errors
                  if (retryCount < maxRetries) {
                    retryCount++;
                    setTimeout(attemptFetch, 1000 * Math.pow(2, retryCount)); // Exponential backoff
                    return;
                  }
                  reject({
                    type: "SERVER_ERROR",
                    message: "Server error. Please try again later.",
                  });
                  break;
                default:
                  reject({
                    type: "UNKNOWN_ERROR",
                    message: `An error occurred: ${response.status} ${response.statusText}`,
                  });
              }
              return null;
            }
            return checkFunction(response);
          })
          .then((response) => {
            if (response) {
              resolve(response);
            } else {
              reject({
                type: "CHECK_FUNCTION_FAILED",
                message: "Failed to process response",
              });
            }
          })
          .catch((error) => {
            console.error("Fetch error:", error);

            // Handle network errors with retry
            if (error.name === "TypeError" && retryCount < maxRetries) {
              retryCount++;
              setTimeout(attemptFetch, 1000 * Math.pow(2, retryCount)); // Exponential backoff
              return;
            }

            if (error.type) {
              reject(error);
            } else if (error.name === "TypeError") {
              reject({
                type: "NETWORK_ERROR",
                message:
                  "Unable to connect to the server. Please check your internet connection.",
              });
            } else if (error.name === "AbortError") {
              reject({
                type: "REQUEST_ABORTED",
                message: "Request was cancelled",
              });
            } else if (error.name === "SyntaxError") {
              reject({
                type: "INVALID_JSON",
                message: "Invalid response from server",
              });
            } else {
              reject({
                type: "UNKNOWN_ERROR",
                message: `An unexpected error occurred: ${error.message}`,
              });
            }
          });
      };

      attemptFetch();
    });
  };

  handleSelectedBrandID = (value) => {
    this.setState({ selectedbrandID: value });
    utilityFunctions.setCookie("brandId", value);
  };

  render() {
    const user = this.state.userInfo;
    const isPtcUser = !!user?.user?.service_center?.find((s) =>
      s.name?.toLowerCase().includes("ptc")
    );

    const isAdminSCA = hasRole(user, ROLES.SERVICE_CENTER_ADMIN);
    const isContractor = hasRole(user, ROLES.CONTRACTOR);
    const isAdminOnly = hasRole(user, ROLES.ADMIN);
    const isShowDashboard = isAdminOnly || (isPtcUser && isAdminSCA);

    const isAdmin = hasRole(user, [ROLES.ADMIN, ROLES.SERVICE_CENTER_ADMIN]);
    const isCommercial = hasRole(user, [
      ROLES.COMMERCIAL_ADMIN,
      ROLES.COMMERCIAL_STAFF,
    ]);

    if (this.state.isLoading) {
      return <LoadingPage />;
    }
    return (
      <Router>
        <Switch>
          {/* Use conditionals to control whether user has access to paths */}

          {isShowDashboard && (
            <ProtectedRoute
              exact
              path="/"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  logout={this.handleLogout}
                  userInfo={this?.state?.userInfo}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Dashboard
                    protectedFetch={this.protectedFetch}
                    userInfo={this?.state?.userInfo}
                  />
                </PageWithNavbar>
              )}
            />
          )}

          {!isContractor && (
            <ProtectedRoute
              exact
              path={"/"}
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Warranties
                    selectedbrandID={this.state.selectedbrandID}
                    protectedFetch={this.protectedFetch}
                  />
                </PageWithNavbar>
              )}
            />
          )}
          {!isContractor && (
            <ProtectedRoute
              exact
              path={"/tickets"}
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Warranties
                    selectedbrandID={this.state.selectedbrandID}
                    protectedFetch={this.protectedFetch}
                  />
                </PageWithNavbar>
              )}
            />
          )}
          {isContractor && (
            <ProtectedRoute
              exact
              path={"/ticket-search"}
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <SearchTicket
                    selectedbrandID={this.state.selectedbrandID}
                    protectedFetch={this.protectedFetch}
                    userInfo={this?.state?.userInfo}
                  />
                </PageWithNavbar>
              )}
            />
          )}
          {isContractor && (
            <ProtectedRoute
              exact
              path={"/"}
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <SearchTicket
                    selectedbrandID={this.state.selectedbrandID}
                    protectedFetch={this.protectedFetch}
                    userInfo={this?.state?.userInfo}
                  />
                </PageWithNavbar>
              )}
            />
          )}

          {isContractor && (
            <ProtectedRoute
              exact
              path={"/ticket/:id"}
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={(props) => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <TicketDetail
                    selectedbrandID={this.state.selectedbrandID}
                    protectedFetch={this.protectedFetch}
                    {...props}
                  />
                </PageWithNavbar>
              )}
            />
          )}
          {/* Warranties is home for not super and not home for super */}
          {isCommercial && (
            <ProtectedRoute
              exact
              path={"/commercial/tickets"}
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={(props) => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Warranties
                    selectedbrandID={this.state.selectedbrandID}
                    userInfo={this?.state?.userInfo}
                    protectedFetch={this.protectedFetch}
                    {...props}
                  />
                </PageWithNavbar>
              )}
            />
          )}

          {isCommercial && (
            <ProtectedRoute
              exact
              path="/commercial/customer-list"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={(props) => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Customers
                    protectedFetch={this.protectedFetch}
                    isSuper={this.state.isSuper}
                    selectedbrandID={this.state.selectedbrandID}
                    userInfo={this?.state?.userInfo}
                    {...props}
                  />
                </PageWithNavbar>
              )}
            />
          )}
          {isCommercial && (
            <ProtectedRoute
              exact
              path="/commercial/staffs"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={(props) => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Customers
                    protectedFetch={this.protectedFetch}
                    isSuper={this.state.isSuper}
                    selectedbrandID={this.state.selectedbrandID}
                    userInfo={this?.state?.userInfo}
                    {...props}
                  />
                </PageWithNavbar>
              )}
            />
          )}
          {isCommercial && (
            <ProtectedRoute
              exact
              path="/commercial/warranty/:id"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={(props) => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <SingleWarranty
                    protectedFetch={this.protectedFetch}
                    isSuper={this.state.isSuper}
                    selectedbrandID={this.state.selectedbrandID}
                    userInfo={this.state.userInfo}
                    // employees={this.state.employees}
                    {...props}
                  />
                </PageWithNavbar>
              )}
            />
          )}

          <ProtectedRoute
            exact
            path="/customer-list"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <Customers
                  protectedFetch={this.protectedFetch}
                  isSuper={this.state.isSuper}
                  selectedbrandID={this.state.selectedbrandID}
                  userInfo={this?.state?.userInfo}
                  {...props}
                />
              </PageWithNavbar>
            )}
          />
          <ProtectedRoute
            exact
            path="/inventory"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={() => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <Inventory
                  selectedbrandID={this.state.selectedbrandID}
                  protectedFetch={this.protectedFetch}
                  userInfo={this.state.userInfo}
                />
              </PageWithNavbar>
            )}
          />
          <ProtectedRoute
            exact
            path="/reports"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={() => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <Reports
                  selectedbrandID={this.state.selectedbrandID}
                  protectedFetch={this.protectedFetch}
                />
              </PageWithNavbar>
            )}
          />
          <ProtectedRoute
            exact
            path="/warranty/:id"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <SingleWarranty
                  protectedFetch={this.protectedFetch}
                  isSuper={this.state.isSuper}
                  selectedbrandID={this.state.selectedbrandID}
                  userInfo={this.state.userInfo}
                  // employees={this.state.employees}
                  {...props}
                />
              </PageWithNavbar>
            )}
          />
          <ProtectedRoute
            exact
            path="/customer-detail/:id"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <CustomerDetail
                  protectedFetch={this.protectedFetch}
                  isSuper={this.state.isSuper}
                  selectedbrandID={this.state.selectedbrandID}
                  {...props}
                  userInfo={this?.state?.userInfo}
                />
              </PageWithNavbar>
            )}
          />
          <ProtectedRoute
            exact
            path="/commercial-customer/:id"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <CustomerDetail
                  protectedFetch={this.protectedFetch}
                  isSuper={this.state.isSuper}
                  selectedbrandID={this.state.selectedbrandID}
                  userInfo={this?.state?.userInfo}
                  {...props}
                />
              </PageWithNavbar>
            )}
          />
          <ProtectedRoute
            exact
            path="/commercial-customer/:id"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <Customers
                  protectedFetch={this.protectedFetch}
                  isSuper={this.state.isSuper}
                  selectedbrandID={this.state.selectedbrandID}
                  userInfo={this?.state?.userInfo}
                  {...props}
                />
              </PageWithNavbar>
            )}
          />

          <ProtectedRoute
            exact
            path="/service-center/:id"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <ServiceCenterDetail
                  protectedFetch={this.protectedFetch}
                  isSuper={this.state.isSuper}
                  selectedbrandID={this.state.selectedbrandID}
                  {...props}
                />
              </PageWithNavbar>
            )}
          />

          {isAdmin ? (
            <ProtectedRoute
              exact
              path="/stores"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Sellers
                    protectedFetch={this.protectedFetch}
                    userInfo={this?.state?.userInfo}
                  />
                </PageWithNavbar>
              )}
            />
          ) : null}

          <ProtectedRoute
            exact
            path="/service-centers"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <ServiceCenterList
                  protectedFetch={this.protectedFetch}
                  userInfo={this?.state?.userInfo}
                  isSuper={this.state.isSuper}
                  selectedbrandID={this.state.selectedbrandID}
                  {...props}
                />
              </PageWithNavbar>
            )}
          />

          {isAdmin ? (
            <ProtectedRoute
              exact
              path="/manage-staff"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <ManageStaff protectedFetch={this.protectedFetch} />
                </PageWithNavbar>
              )}
            />
          ) : null}
          {isAdmin ? (
            <ProtectedRoute
              exact
              path="/device"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Device
                    protectedFetch={this.protectedFetch}
                    selectedbrandID={this.state.selectedbrandID}
                  />
                </PageWithNavbar>
              )}
            />
          ) : null}
          {isAdmin ? (
            <ProtectedRoute
              exact
              path="/device-detail/:id"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={(props) => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <DeviceDetail
                    protectedFetch={this.protectedFetch}
                    selectedbrandID={this.state.selectedbrandID}
                    {...props}
                  />
                </PageWithNavbar>
              )}
            />
          ) : null}

          {/* <ProtectedRoute
            exact
            path="/commercial/:id"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <Commercial
                  protectedFetch={this.protectedFetch}
                  selectedbrandID={this.state.selectedbrandID}
                  {...props}
                  userInfo={this?.state?.userInfo}
                />
              </PageWithNavbar>
            )}
          /> */}

          <ProtectedRoute
            exact
            path="/staff-detail/:id"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <StaffDetail
                  protectedFetch={this.protectedFetch}
                  isSuper={this.state.isSuper}
                  {...props}
                />
              </PageWithNavbar>
            )}
          />

          <ProtectedRoute
            exact
            path="/staff-new"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={(props) => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <StaffAdd
                  protectedFetch={this.protectedFetch}
                  isSuper={this.state.isSuper}
                  {...props}
                />
              </PageWithNavbar>
            )}
          />

          <ProtectedRoute
            exact
            path="/default-settings"
            test={this?.state?.userInfo}
            goToOnFailure={"/login"}
            render={() => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <DefaultSettings
                  protectedFetch={this.protectedFetch}
                  userInfo={this?.state?.userInfo}
                />
              </PageWithNavbar>
            )}
          />

          <ProtectedRoute
            exact
            path="/addnewdevice"
            test={this.state.isAuthenticated}
            goToOnFailure={"/needsverification"}
            render={() => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <AddNewDevice protectedFetch={this.protectedFetch} />
              </PageWithNavbar>
            )}
          />
          {this.state.isSuper && (
            <ProtectedRoute
              exact
              path="/users"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={() => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <Users protectedFetch={this.protectedFetch} />
                </PageWithNavbar>
              )}
            />
          )}
          {this.state.isSuper && (
            <ProtectedRoute
              exact
              path="/user/:id"
              test={this?.state?.userInfo}
              goToOnFailure={"/login"}
              render={(props) => (
                <PageWithNavbar
                  userInfo={this?.state?.userInfo}
                  logout={this.handleLogout}
                  isSuper={this.state.isSuper}
                  protectedFetch={this.protectedFetch}
                  handleSelectedBrandID={this.handleSelectedBrandID}
                >
                  <SingleUser protectedFetch={this.protectedFetch} {...props} />
                </PageWithNavbar>
              )}
            />
          )}
          <ProtectedRoute
            exact
            path="/login"
            test={true}
            goToOnFailure={"/notfound"}
            render={(props) => (
              <AuthContainer>
                <Login onLogin={this.userHasAuthenticated} {...props} />
              </AuthContainer>
            )}
          />
          <ProtectedRoute
            exact
            path="/forgot-password"
            test={true}
            goToOnFailure={"/notfound"}
            render={(props) => (
              <AuthContainer>
                <ForgotPassword
                  protectedFetch={this.protectedFetch}
                  {...props}
                />
              </AuthContainer>
            )}
          />
          <ProtectedRoute
            exact
            path="/commercial/forgot-password"
            test={true}
            goToOnFailure={"/notfound"}
            render={(props) => (
              <AuthContainer>
                <ForgotPassword
                  protectedFetch={this.protectedFetch}
                  {...props}
                />
              </AuthContainer>
            )}
          />
          <ProtectedRoute
            exact
            path="/forgot-password-confirm"
            test={true}
            goToOnFailure={"/notfound"}
            render={(props) => (
              <AuthContainer>
                <ForgotPasswordConfirm
                  protectedFetch={this.protectedFetch}
                  {...props}
                />
              </AuthContainer>
            )}
          />
          <ProtectedRoute
            exact
            path="/commercial/forgot-password-confirm"
            test={true}
            goToOnFailure={"/notfound"}
            render={(props) => (
              <AuthContainer>
                <ForgotPasswordConfirm
                  protectedFetch={this.protectedFetch}
                  {...props}
                />
              </AuthContainer>
            )}
          />
          <ProtectedRoute
            exact
            path="/commercial"
            test={true}
            goToOnFailure={"/notfound"}
            render={(props) => (
              <AuthContainer>
                <Login onLogin={this.userHasAuthenticated} {...props} />
              </AuthContainer>
            )}
          />
          {/* Finally, catch all unmatched routes */}
          <Route path="/error" component={ErrorPage} />
          <Route
            render={() => (
              <PageWithNavbar
                userInfo={this?.state?.userInfo}
                logout={this.handleLogout}
                isSuper={this.state.isSuper}
                protectedFetch={this.protectedFetch}
                handleSelectedBrandID={this.handleSelectedBrandID}
              >
                <NotFound />
              </PageWithNavbar>
            )}
          />
        </Switch>
      </Router>
    );
  }
}

//Show if route shouldn't be available
class ProtectedRoute extends React.Component {
  render() {
    const { ...props } = this.props;
    return (
      <Route
        {...props}
        render={() =>
          this.props?.test ? (
            this.props.render(this.props)
          ) : (
            <Redirect to={this.props.goToOnFailure} />
          )
        }
      />
    );
  }
}
